module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.a4a71b0.woff2";